<!--
   Created by qing on 2020/8/19
   Des: 
-->
<template>
	<div class="mine-container">
		<div
			class="mine-header"
			v-if="userInfo"
		>
			<van-image
				class="mine-header__user-image"
				width="60px"
				height="60px"
				fit="cover"
				radius="6"
				:src="userInfo.headImg"
			>
			</van-image>
			<div class="mine-header__user-info">
				<div class="user-info__nick-name">{{ userInfo.userName }}</div>
				<div class="user-info__account">{{ actionPhoneSeparated(userInfo.telephone) }}</div>
			</div>
		</div>
		
		<div class="cell-box">
			<van-cell
				:is-link="!isWxWork"
				title="当前团队"
				@click="onClickCompany"
				class="company-cell"
			>
				<div class="active-company">
					<div class="van-cell-text">{{ currentCompany ? currentCompany.companyName : '' }}</div>
				</div>
			</van-cell>
			
			<!--v-if="permission && (permission.creator || permission.topAdmin)"-->
			<van-cell
				v-if="false"
				@click="onClickTeamApply"
				is-link
			>
				<div slot="title">
					成员申请 <span v-if="applyNum > 0">({{applyNum}})</span>
				</div>
			</van-cell>
			
			<van-cell
				is-link
				@click="onClickTempCenter"
				class="mine-body__company-select"
			>
				<div slot="title">
					应用中心
				</div>
			</van-cell>
			
			<van-cell
				v-if="!$store.getters.functionConfigMap.hasOwnProperty('sys_showUserOrderCenter') || $store.getters.functionConfigMap.sys_showUserOrderCenter.showFunction"
				is-link
				@click="onClickOrder"
				class="mine-body__company-select"
			>
				<div slot="title">
					我的订单
				</div>
			</van-cell>
			
			<van-cell
				v-if="showLarkBtn"
				is-link
				@click="larkAppRemove"
				class="mine-body__company-select"
			>
				<div slot="title">
					飞书应用卸载
				</div>
			</van-cell>
			
			<van-cell
				v-if="showLarkBtn"
				is-link
				@click="larkUnbinding"
				class="mine-body__company-select"
			>
				<div slot="title">
					飞书解绑并退出团队
				</div>
			</van-cell>
			
			<van-cell
				v-for="item in articleList"
				:key="item.sortIndex"
				is-link
				:title="item.pageTitle"
				@click="onclickArticleItem(item)"
			>
			</van-cell>
		</div>

		<div class="activity-image-container">

			<div
				class="activity-image-item"
				v-for="item in activityList"
				:key="item.sortIndex"
			>

				<van-image
					class="activity-image"
					width="100%"
					height="50"
					radius="5px"
					fit="cover"
					@click="onclickArticleItem(item)"
					:src="item.imageUrl"
				>
				</van-image>
			</div>
		</div>

		<div class="version">
			Ver：{{version}}
		</div>

		<van-action-sheet
			v-model="showCompanyList"
			:actions="actions"
			cancel-text="取消"
			close-on-click-action
			@select="onSelectCompany"
		/>
	</div>
</template>

<script>
	import {
		phoneSeparated
	} from "../../../assets/js/Untis";
	import {
		ENV_TYPE_LARK_MINI_PROGRAM
	} from "../../store/types";

	export default {
		data() {
			return {
				userInfo: null,
				currentCompany: null,
				articleList: [],
				activityList: [],
				version: '2.6.2',
				permission: {},
				applyNum: 0,
				aEle: null,

				showCompanyList: false,
				companyList: [],
				isWxWork: false
			}
		},
		created() {
			this.isWxWork = window.isWxWork
			this.userInfo = this.$store.getters.userInfo
			this.currentCompany = this.$store.getters.company
			this.permission = this.$store.getters.adminInfo

			this.$store.dispatch('actionCompanyWaitHandleMember')
				.then(res => {
					this.applyNum = res.unConfirm
				})
				.catch(console.error)

			this.$store.dispatch('actionFetchActivityList')
				.then(res => {
					this.articleList = res.articleList
					this.activityList = res.activityList
				})
				.catch(console.error)

			this.aEle = document.createElement('a')
			this.$store.dispatch('setPageTitle', '我的')
		},
		computed: {
			showLarkBtn() {
				const arrTemp = [
					"http://192.168.50.35",
					"127.0.0.1",
					'https://node.dev.161.54188.online',
				]
				console.log(this.$route, window.location.href)
				return (window.isLark || this.$store.getters.env === ENV_TYPE_LARK_MINI_PROGRAM) &&
					arrTemp.some(item => window.location.href.includes(item))
			},
			actions() {
				const arr = []
				this.companyList.forEach(item => {
					arr.push({
						name: item.companyName,
						...item
					})
				})
				return arr
			}
		},
		methods: {
			actionPhoneSeparated(tel) {
				if (!tel) {
					return ''
				}
				return phoneSeparated(tel)
			},
			onClickTempCenter() {
				const toast = this.$toast.loading({
					message: '加载中...'
				})
				this.$store.dispatch('reqNodeSave', {
						userId: this.$store.getters.userId,
						userInfo: this.$store.getters.userInfo,
						company: this.$store.getters.company,
						token: this.$store.state.token,
					})
					.then(res => {
						this.$router.push({
							name: 'templateList',
							query: {
								key: res.nodeKey
							}
						})
					})
					.catch(err => {
						console.error(err)
					})
					.finally(() => {
						toast.clear()
					})
			},
			onClickOrder() {
				this.$router.push({
					name: 'orderCenter'
				})
			},
			onClickTeamApply() {
				const toast = this.$toast.loading({
					message: '加载中...'
				})
				this.$store.dispatch('reqNodeSave', {
						userId: this.$store.getters.userId,
						companyId: this.$store.getters.currentCompanyId,
						token: this.$store.state.token,
					})
					.then(res => {
						this.$router.push({
							name: 'teamApply',
							query: {
								key: res.nodeKey
							}
						})
					})
					.catch(err => {
						console.error(err)
					})
					.finally(() => {
						toast.clear()
					})
			},

			onclickArticleItem(item) {
				if (!item.jumpUrl) {
					this.$toast.fail('跳转地址不存在')
					return
				}
				if (this.aEle) {
					this.aEle.href = item.jumpUrl
					this.aEle.target = '_blank'
					this.aEle.click()
				}
			},

			larkAppRemove() {
				this.$store.dispatch('actionLarkAppRemove', {
					tenantKey: this.$store.state.tenantKey
				}).then(res => {
					this.$toast.success('应用卸载成功')
					tt.miniProgram.navigateBack()
				}).catch(console.error)
			},

			larkUnbinding() {
				this.$store.dispatch('actionLarkUnbinding', {
					userId: this.$store.getters.userId,
					companyId: this.$store.getters.currentCompanyId
				}).then(res => {
					this.$toast.success('退出团队成功')
					tt.miniProgram.navigateBack()
				}).catch(console.error)
			},

			onClickCompany() {
				if (this.isWxWork) {
					return
				}
				if (!this.companyList || !this.companyList.length) {
					this.$store.dispatch('actionCompanyList', {
						userId: this.$store.getters.userId
					}).then(res => {
						this.companyList = res
					}).catch(console.error)
				}

				this.showCompanyList = true
			},

			onSelectCompany(item) {
				this.currentCompany = item
				this.$store.commit('UPDATE__COMPANY', item)
				this.$store.commit('UPDATE__COMPANY_ID', item.companyId)
				this.$toast(`已切换到「${item.companyName}」`)
			}
		}
	}
</script>

<style lang="less">
	.mine-container {
		height: 100%;
		overflow: auto;
		box-sizing: border-box;
		-webkit-overflow-scrolling: touch;

		.mine-header {
			height: 80px;
			width: 100%;
			border-bottom: 1px solid #ebedf0;
			background-color: #FFFFFF;
			margin-bottom: 10px;
			display: flex;
			padding: 18px 20px 18px 0;
			align-items: center;
			box-sizing: border-box;
		}

		.mine-header__user-image {
			margin-left: 16px;
			margin-right: 12px;
			border-radius: 6px;
		}

		.mine-header__user-info {
			flex: 1;
			justify-items: center;
			display: flex;
			flex-direction: column;
			margin-left: 10px;
		}

		.user-info__nick-name {
			font-size: 18px;
			color: #282828;
			line-height: 32px;
			font-weight: bold;
		}

		.user-info__account {
			font-size: 14px;
			color: #656565;
			line-height: 26px;
		}

		.mine-body__company-select {
			margin-bottom: 10px;
		}

		.mine-body__company-handler {
			width: 100%;
			margin-bottom: 10px;
			height: 140px;
			background-color: #FFFFFF;
		}

		.company-handler__title {
			font-size: 14px;
			color: #323233;
			margin-left: 10px;
			background-color: #FFFFFF;
			padding-top: 10px;
		}

		.company-handler__image-container {
			width: 100%;
			margin-top: 12px;
			display: flex;
			justify-content: space-around;
			background-color: #FFFFFF;
		}

		.van-popup.van-popup--center.van-popup--safe {
			background-color: transparent;
		}

		.footer-button-container {
			display: flex;
			justify-content: space-around;
			margin-top: 15px;
		}

		.activity-image-container {
			width: 100%;
			background-color: transparent;
			margin: 10px 0;
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.activity-image-item {
			width: 90%;
			height: 100px;
			background-color: transparent;
			border-radius: 5px;
			margin-bottom: 10px;
		}

		.active-company {
			display: flex;
			justify-content: flex-end;
		}

		.van-tag {
			margin-right: 10px;
		}

		.version {
			position: fixed;
			color: #969799;
			height: 30px;
			line-height: 30px;
			font-size: 14px;
			bottom: calc(50px + env(safe-area-inset-bottom));
			left: 0;
			right: 0;
			text-align: center;
		}
		
		.cell-box{
			padding: 0 10px;
		}

		.van-cell {
			justify-content: space-between;
			line-height: 2.5;
			align-items: center;
		}

		.van-cell__title {
			width: calc(100% - 30px);
			flex: none !important;
			-webkit-flex: none !important;
		}

		.company-cell {
			.van-cell__title {
				width: auto;
			}
		}

		.van-cell-text {
			/*flex: 1;*/
			max-width: calc(100% - 50px);
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.subscribe-cell .van-cell__title {
			width: 300px;
		}

		.company-list-item {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			text-align: center;
			height: 50px;
			padding: 0;
			line-height: 50px;
			font-size: 16px;
			background-color: #fff;
			border-bottom: 1px solid #ebedf0;
		}

		.company-name {
			max-width: 70%;
			display: inline-block;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.ext-tip {
			display: inline-block;
			line-height: 50px;
			font-size: 12px;
			color: darkgray;

		}
	}
</style>
